import { AuthCacheKey, AuthIdCacheKey, LangCacheKey } from "@common/config";
import { EVENT_LOGIN_OUT, EVENT_USERINFO_SUCCESS } from "@common/event";
import { getFromLocalStorage, setToLocalStorage } from "@common/util";
import { callBridgeFunc } from "@common/bridge";
import i18n from "../i18n.js";
import { useEffect, useState } from "react";
import PubSub from "pubsub-js";

export default function useUserInfo() {
  const [user, setUser] = useState<API.UserInfo | null>();
  // JSON.parse(getFromLocalStorage('userInfo') || '{}')
  const [deviceInfo, setDeviceInfo] = useState<API.DeviceInfo | null>({});

  useEffect(() => {
    const sub = PubSub.subscribe(EVENT_LOGIN_OUT, () => {
      setUser({});
    });
    return () => {
      PubSub.unsubscribe(sub);
    };
  }, []);

  const updateUserInfo = () => {
    callBridgeFunc("getUserInfo", (data: string) => {
      const dataObj = JSON.parse(data);
      setUser(Object.assign({}, user, dataObj));
      // setUser((prev) => Object.assign({}, prev ?? {}, dataObj));
      console.log("登录信息：", Object.assign({}, user, dataObj));
    });
  };

  const updateDeviceInfo = () => {
    callBridgeFunc("getDeviceInfo", (data: string) => {
      const dataObj = JSON.parse(data);
      setDeviceInfo(Object.assign({}, dataObj));
    });
  };

  useEffect(() => {
    updateUserInfo();
    updateDeviceInfo();
  }, []);

  useEffect(() => {
    setToLocalStorage("userInfo", user || "");
    setToLocalStorage(AuthCacheKey, user?.token || "");
    setToLocalStorage(AuthIdCacheKey, user?.uid || "");
    setToLocalStorage("versionNum", user?.versionNum || "");
    const lang = user?.languageType || "en";
    setToLocalStorage(LangCacheKey, lang);
    i18n.changeLanguage(lang);

    //  1v1主播号  godType: 2      AUTHORIZATION_TOKEN_10000214_f6dee5f2c5ae44f68742bf42ce28ebc7
    //  语音主播号  godType: 1     AUTHORIZATION_TOKEN_10000726_6fed5210c006481d9c67b0b7fc581684

    // setToLocalStorage(AuthCacheKey, user?.token || 'AUTHORIZATION_TOKEN_10000214_f6dee5f2c5ae44f68742bf42ce28ebc7');
    // setToLocalStorage(AuthIdCacheKey, user?.uid || '10000214');

    // setToLocalStorage(AuthCacheKey, user?.token || 'AUTHORIZATION_TOKEN_10000726_a922c480cb784b0d97401f092b4238b6');
    // setToLocalStorage(AuthIdCacheKey, user?.uid || '10000726');

    // host center 测试账号
    // setToLocalStorage(AuthCacheKey, user?.token || 'AUTHORIZATION_TOKEN_10000466_7905a2b9f7584dd0be34d8db0e624d27');
    // setToLocalStorage(AuthIdCacheKey, user?.uid || '10000466');

    //  这个是测试组播中心工资档位调试的账号
    // setToLocalStorage(AuthCacheKey, user?.token || 'AUTHORIZATION_TOKEN_10000621_2fe32a5ff3924c8ebb40eb675286974d');
    // setToLocalStorage(AuthIdCacheKey, user?.uid || '10000621');

    // setToLocalStorage(AuthCacheKey, user?.token || "AUTHORIZATION_TOKEN_10001084_088bb960c05a4a7d976f91bec21be3c1");
    // setToLocalStorage(AuthIdCacheKey, user?.uid || "10001084");

    // setToLocalStorage(AuthCacheKey, user?.token || "AUTHORIZATION_TOKEN_10001154_a66765509fbc4f65a94c0aeaaac93810");
    // setToLocalStorage(AuthIdCacheKey, user?.uid || "10001154"); // 1v1主播

    // 测试提现的
    // setToLocalStorage(AuthCacheKey, user?.token || "AUTHORIZATION_TOKEN_10000817_6994e3c27ccd47539273504a43db0fc8");
    // setToLocalStorage(AuthIdCacheKey, user?.uid || "10000817");

    // 测试提现的  主播
    // setToLocalStorage(AuthCacheKey, user?.token || "AUTHORIZATION_TOKEN_10000558_597129564bc248988033bc9243d2df66");
    // setToLocalStorage(AuthIdCacheKey, user?.uid || "10000558");

    //  这个是公会会长的 ，测试my-agency的样式
    // setToLocalStorage(AuthCacheKey, user?.token || "AUTHORIZATION_TOKEN_10000013_b375c2e5bc7d416493a5bc01f04a73da");
    // setToLocalStorage(AuthIdCacheKey, user?.uid || "10000013");
  }, [user]);

  useEffect(() => {
    setToLocalStorage("statusHeight", deviceInfo?.statusHeight || 0);
  }, [deviceInfo]);

  return {
    user,
    setUser,
    deviceInfo,
  };
}
